import { render, staticRenderFns } from "./ProfilePictureSelection.vue?vue&type=template&id=f130d6c6&scoped=true"
import script from "./ProfilePictureSelection.vue?vue&type=script&lang=js"
export * from "./ProfilePictureSelection.vue?vue&type=script&lang=js"
import style0 from "./ProfilePictureSelection.vue?vue&type=style&index=0&id=f130d6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f130d6c6",
  null
  
)

export default component.exports